<template>
  <div class="main_content">
    <!-- 左右联动区域 -->
    <div class="linkageContainer">
      <!-- 左侧菜单 -->
      <div class="leftMenu">
        <el-tooltip 
          v-for="(item, index) in menuList" 
          :key="index"
          :content="item.title"
          placement="right"
          effect="dark"
        >
          <div 
            :class="['menuItem', { active: activeIndex === index }]"
            @click="scrollToSection(index)"
          >
            {{ item.title }}
          </div>
        </el-tooltip>
      </div>

      <!-- 右侧内容 -->
      <div class="rightContent" ref="rightContent" @scroll="handleScroll">
        <div 
          v-for="(item, index) in menuList" 
          :key="index"
          :ref="'section' + index"
          class="contentSection"
        >
          <div class="sectionHeader">
            <span class="dot"></span>
            <h3 class="sectionTitle">{{ item.title }}</h3>
          </div>
          <p class="sectionDesc" v-html="item.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 0,
      isScrolling: false,
    };
  },
  mounted() {
  },
  watch: {
    functiondata: {
      handler(newVal) {
        if (newVal && newVal.length > 0) { }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 点击左侧菜单，滚动到对应内容
    scrollToSection(index) {
      this.isScrolling = true;
      this.activeIndex = index;
      
      const section = this.$refs['section' + index];
      const container = this.$refs.rightContent;
      
      if (section && section[0] && container) {
        const offsetTop = section[0].offsetTop - container.offsetTop;
        container.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
        
        // 滚动完成后重置标志
        setTimeout(() => {
          this.isScrolling = false;
        }, 500);
      }
    },
    
    // 右侧滚动时，更新左侧选中状态
    handleScroll() {
      if (this.isScrolling) return;
      
      const container = this.$refs.rightContent;
      const scrollTop = container.scrollTop;
      const containerTop = container.offsetTop;
      
      let currentIndex = 0;
      
      for (let i = 0; i < this.menuList.length; i++) {
        const section = this.$refs['section' + i];
        if (section && section[0]) {
          const sectionTop = section[0].offsetTop - containerTop;
          if (scrollTop >= sectionTop - 150) {
            currentIndex = i;
          }
        }
      }
      
      this.activeIndex = currentIndex;
    },
  },
};
</script>

<style scoped lang="scss">
.main_content {
  background: #fff;
  .productShowcase {
    background: #f8f9fb;
    padding: 60px 0 80px;
    
    .showcaseTabs {
      display: flex;
      justify-content: center;
      gap: 20px;
      margin-bottom: 50px;
      background-color: #f5f5f7;
      border-radius: 25px;
      width: fit-content;
      margin: 0 auto 50px;
      
      .tabItem {
        padding: 8px 15px;
        font-size: 16px;
        color: #666;
        cursor: pointer;
        border-radius: 25px;
        transition: all 0.3s;
        
        &:hover {
          color: #2a82e4;
        }
        
        &.active {
          background: #2a82e4;
          color: #fff;
        }
      }
    }
    
    .showcaseContent {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 60px;
      
      .carouselWrapper {
        position: relative;
        display: flex;
        align-items: center;
        
        .navBtn {
          position: absolute;
          z-index: 10;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #fff;
          border: none;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
          
          i {
            font-size: 20px;
            color: #666;
          }
          
          &:hover {
            background: #2a82e4;
            
            i {
              color: #fff;
            }
          }
          
          &.prevBtn {
            left: 0;
          }
          
          &.nextBtn {
            right: 0;
          }
        }
        
        .productCarousel {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          scroll-behavior: smooth;
          padding: 20px 70px;
          margin: 0 -10px;
          
          &::-webkit-scrollbar {
            display: none;
          }
          
          .productCard {
            flex-shrink: 0;
            width: 280px;
            background: #fff;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            cursor: pointer;
            transition: all 0.3s;
            
            &:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
            }
            
            .cardImage {
              height: 200px;
              background: linear-gradient(135deg, #f0f5ff 0%, #e8f4ff 100%);
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
              
              img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
              }
            }
            
            .cardInfo {
              padding: 20px;
              color: #333;
              
              .cardTitle {
                font-size: 16px;
                font-weight: 600;
                margin: 0 0 8px;
                line-height: 1.4;
              }
              
              .cardName {
                font-size: 14px;
                margin: 0 0 20px;
              }
              
              .cardActions {
                display: flex;
                gap: 12px;
                
                .downloadBtn {
                  width: 38%;
                  padding: 6px 0;
                  font-size: 14px;
                  color: #fff;
                  background: #2a82e4;
                  border: none;
                  border-radius: 25px;
                  cursor: pointer;
                  transition: all 0.3s;
                  
                  &:hover {
                    background: #1a6fc9;
                  }
                }
                
                .moreBtn {
                  width: 38%;
                  padding: 6px 0;
                  font-size: 14px;
                  color: #666;
                  background: #f5f5f7;
                  border: none;
                  border-radius: 25px;
                  cursor: pointer;
                  transition: all 0.3s;
                  
                  &:hover {
                    border-color: #2a82e4;
                    color: #2a82e4;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // 左右联动区域
  .linkageContainer {
    display: flex;
    max-width: 1400px;
    margin: 0 auto;
    padding: 40px 0;
    min-height: 800px;
    
    // 左侧菜单
    .leftMenu {
      width: 200px;
      flex-shrink: 0;
      padding-right: 30px;
      position: sticky;
      top: 100px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      
      .menuItem {
        width: 100%;
        padding: 8px 15px;
        font-size: 13px;
        color: #666;
        background-color: #f5f5f7;
        cursor: pointer;
        border-radius: 25px;
        margin-bottom: 8px;
        transition: all 0.3s;
        border: 1px solid transparent;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        
        &:hover {
          color: #2a82e4;
          background: #f5f9ff;
        }
        
        &.active {
          color: #fff;
          background: #2a82e4;
          border-color: #2a82e4;
        }
      }
    }
    
    // 右侧内容
    .rightContent {
      flex: 1;
      max-height: 900px;
      overflow-y: auto;
      padding-right: 20px;
      
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f5f5f5;
      }
      
      .contentSection {
        margin-bottom: 60px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .sectionHeader {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          
          .dot {
            width: 8px;
            height: 8px;
            background: #2a82e4;
            border-radius: 50%;
            margin-right: 12px;
          }
          
          .sectionTitle {
            font-size: 20px;
            font-weight: 600;
            color: #333;
            margin: 0;
          }
        }
        
        .sectionDesc {
          font-size: 14px;
          color: #666;
          line-height: 1.8;
          margin-bottom: 20px;
          ::v-deep img{
            max-width: 100%;
            height: auto;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          }
        }
      }
    }
  }

  // 竞品对比
  .intro {
    text-align: center;
    display: flex;
    flex-direction: column;

    .introDes {
      font-size: 30px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 43.44px;
      color: #cccccc;
      text-align: center;
      vertical-align: top;
    }

    .introText {
      font-size: 40px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 57.92px;
      text-align: center;
      vertical-align: top;
    }
  }

  .mianCenter {
    width: 1350px;
    margin: 0 auto;
  }

  .uniqueBg {
    padding-bottom: 100px;

    .comparisonTable {
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      margin-bottom: 40px;

      table {
        width: 100%;
        border-collapse: collapse;

        thead {
          tr {
            th {
              padding: 20px 30px;
              font-size: 23px;
              font-weight: 600;
              border-bottom: 1px solid #eee;

              &.featureCol {
                text-align: left;
                color: #333;
                width: 30%;
              }

              &.otherCol {
                text-align: center;
                color: #666;
                width: 35%;
              }

              &.summitCol {
                text-align: center;
                color: #2a82e4;
                width: 35%;
              }
            }
          }
        }

        tbody {
          tr {
            transition: background-color 0.3s ease;

            &:hover {
              background-color: #f8faff;
            }

            td {
              padding: 18px 30px;
              font-size: 20px;
              font-weight: 600;
              border-bottom: 1px solid #f0f0f0;

              &.featureCol {
                text-align: left;
                color: #333;
                padding-left: 40px;
              }

              &.otherCol {
                text-align: center;
                color: #666;
              }

              &.summitCol {
                text-align: center;
              }

              .icon-cross {
                color: #e74c3c;
                font-size: 20px;
                font-weight: bold;
              }

              .icon-check {
                color: #27ae60;
                font-size: 22px;
                font-weight: bold;
              }

              .text-gray {
                color: #888;
              }

              .text-highlight {
                color: #27ae60;
                font-weight: 600;
              }
            }

            &:last-child td {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>